import { render, staticRenderFns } from "./ActionRevisarInforme.vue?vue&type=template&id=7fd92fa1&lang=pug"
import script from "./ActionRevisarInforme.vue?vue&type=script&lang=js"
export * from "./ActionRevisarInforme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports